(function ($) {
  $(function () {
    var promoBannerFixed = $(".promo-fixed");
    var promoBanner = $(".promo__banner");

    if ($(".promo__banner").length === 0) {
      return;
    }

    var promoClose = $("#close-promo-banner");

    var $stickyEl = $(".js-site-navigation");

    var $fixedMobNav = $(".site-header__mobile-tools");

    if (!localStorage.getItem("popupClosed")) {
      promoBanner.slideDown();
    }

    promoClose.on("click", function () {
      $stickyEl.css("top", "");
      if ($fixedMobNav.length > 0) {
        $fixedMobNav.css("top", "");
      }
      promoBanner.slideUp();
      localStorage.setItem("popupClosed", "true");
    });

    $(window).on("scroll", toggleBannerVisibility);

    function toggleBannerVisibility() {
      if (promoBannerFixed) {
        if ($(window).scrollTop() > 0) {
          promoBannerFixed.addClass("fixed");
        } else {
          promoBannerFixed.removeClass("fixed");
        }
      }
    }
  });
})(jQuery);
